import { P } from '@farewill/ui'

const NoResults = ({ type }) => (
  <P>
    No {type} found <span aria-hidden>😶</span>
  </P>
)

export default NoResults
